import React from 'react'
import { AnnounceUrlList } from './AnnounceUrlList'
import Client from '../../models/client'
import { Box, Group, Text, ThemeIcon, Title, Anchor } from '@mantine/core'
import { MegaphoneIcon } from '@phosphor-icons/react'

export type AnnounceModel = {
  id: number
  page_type?: string
  url: string
  rid: string
  rid2?: string
  rid3?: string
  sales_id?: string
  campaign_id?: string
  note?: string
}

export const pageTypeOptions = [
  { label: 'invite', value: 'invite' },
  { label: 'invite2', value: 'invite2' },
]
export const ridTypeOptions = [
  { label: '会員システム', value: 'crm' },
  { label: 'LINE', value: 'line' },
  { label: 'X', value: 'twitter' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'コーポレートサイト', value: 'csite' },
  { label: 'サービスサイト', value: 'ssite' },
  { label: 'アプリ', value: 'app' },
  { label: 'invy', value: 'invy' },
  { label: '店頭', value: 'shop' },
  { label: 'セミナー/相談会', value: 'seminar' },
  { label: '担当からの声かけ', value: 'staff' },
  { label: '社内告知', value: 'company' },
  { label: '郵送', value: 'dm' },
  { label: '同梱', value: 'package' },
]

type Props = { client: Client }

const Announce = ({ client }: Props) => {
  return (
    <Box>
      <Group gap={12} mb={16}>
        <ThemeIcon variant='transparent' color='#4BC1C7'>
          <MegaphoneIcon weight='fill' size={36} />
        </ThemeIcon>
        <Title size={24} fw={600} c='#000000CC'>告知設定</Title>
      </Group>

      <Text fz={14} c='#000000CC' mb={16}>
        告知設定では、紹介者ページを告知する際、その告知場所（紹介者ページへの流入元）を特定するためのパラメータを設定し、告知用の「URL生成」や「QR画像のダウンロード」が可能です。<br />
        ※告知用のURL・QR設定（パラメータの設定）方法については、
        <Anchor
          href="https://www.creativehope.co.jp/invyknowledge/promotion/01"
          target="_blank"
          rel="noopener noreferrer"
          fz={14}
          underline='always'
        >
          マニュアル（invyご利用ガイド）
        </Anchor>
        をご確認ください。<br />
        ※invyのツールは、告知場所を特定するためのパラメータが設定された状態での告知を想定し設計されております。
      </Text>
      <Text fz={14} c='#000000CC' mb={30}>
        パラメータの設定がされていないURLやQRが告知され、紹介が発生しても数値が正しく取得されない場合がありますので、ご注意ください。
      </Text>

      <AnnounceUrlList client={client} />
    </Box>
  )
}
export default Announce
